
import {Saseung3HanjaService} from "./saseung3-hanja.service";

export const Saseung3HanjaInjectables: Array<any> = [
  {
    provide: Saseung3HanjaService,
    useClass: Saseung3HanjaService,
  },
];
